export default __webpack_public_path__ + "static/media/information--pedestrians-crossing--g3.39fc0c2e.png";